'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidPlaystore = function IoAndroidPlaystore(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36 11.9c-1.5 16.7-1 24.4-1 24.4h-30.5s0.5-7.5-1-24.4h8.1c0-4.5 3.7-8.1 8.1-8.1s8.2 3.6 8.2 8.1h8.1z m-16.2-6.1c-3.4 0-6.1 2.7-6.1 6.1h12.1c0-3.4-2.7-6.1-6-6.1z m-4.1 25.3l11.2-6.6-11.2-6.6v13.2z' })
        )
    );
};

exports.default = IoAndroidPlaystore;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-playstore.js
// module id = 2130
// module chunks = 0